import * as types from './types';

export const getDishes = payload => ({
  type: types.DISHES_GET_REQUEST,
  payload,
});

export const updateOrCreateRequest = payload => ({
  type: types.DISHES_CREATE_OR_UPDATE_REQUEST,
  payload,
});

export const getByIdRequest = payload => ({
  type: types.DISHES_GET_BY_ID_REQUEST,
  payload,
});

export const changeDishPosition = payload => ({
  type: types.DISHES_CHANGE_POSITION_REQUEST,
  payload,
});

export const deleteDishes = payload => ({
  type: types.DISHES_DELETE_REQUEST,
  payload,
});

export const resetErrors = payload => ({
  type: types.RESET_DISHES_ERRORS,
  payload,
});

export const changeFormStep = payload => ({
  type: types.CHANGE_FORM_STEP,
  payload,
});

export const resetListData = () => ({
  type: types.RESET_DISHES_LIST_DATA,
});
